import { useMutation } from 'react-query';
// eslint-disable-next-line import/no-unresolved
import { creditsightsSyncDataSubject$, SyncDataSubject } from '@creditsights/creditsights-web';
import { saveWatchlist } from '../../services/user.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () =>
  useMutation<any, void, any, void>(({ id, watchlist }) => saveWatchlist(id, watchlist), {
    onSuccess: () => {
      creditsightsSyncDataSubject$.next(SyncDataSubject.USER_PREFERENCE);
    },
  });
